<template>
  <div>
    <staff v-if="isStaff" />
    <teacher v-if="isTeacher" />
    <student v-if="isStudent" />
    <parent v-if="isParent" />
  </div>
</template>

<script>
import Staff from './staff/index'
import Teacher from './teacher/index'
import Student from './student/index'
import Parent from './parent/index'

export default {
  name: 'homePage',
  components: {
    Staff,
    Teacher,
    Student,
    Parent
  },
  computed: {
    isStaff() {
      return this.$store.getters.isStaffLogin
    },
    isTeacher() {
      return this.$store.getters.isTeacherLogin
    },
    isStudent() {
      return this.$store.getters.isStudentLogin
    },
    isParent() {
      return this.$store.getters.isParentLogin
    }
  }
}
</script>
